import { render, staticRenderFns } from "./rechargeorders.vue?vue&type=template&id=572c7446&"
import script from "./rechargeorders.vue?vue&type=script&lang=js&"
export * from "./rechargeorders.vue?vue&type=script&lang=js&"
import style0 from "./rechargeorders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports